import { forwardRef, type Ref, type SVGProps } from "react";
const IconHouseUserFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.29 11.4 17.2 1.9a2 2 0 0 0-2.4 0L4.71 11.4A2 2 0 0 0 4 12.93V28a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12.93a2 2 0 0 0-.71-1.53m-14.133-.214A4 4 0 0 1 16 10a4 4 0 0 1 3.96 4.04v.817a5.6 5.6 0 0 1-1.714 3.88l1.183.229c2.714.64 4.571 2.011 4.571 3.605v2.286c0 .631-.512 1.143-1.143 1.143H9.143A1.143 1.143 0 0 1 8 24.857v-2.286c0-1.594 1.834-2.965 4.571-3.605l1.143-.252A5.53 5.53 0 0 1 12 14.857v-.817a4 4 0 0 1 1.157-2.854"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHouseUserFilledSVG);
ForwardRef.displayName = "IconHouseUserFilled";
export { ForwardRef as IconHouseUserFilled };
